import Icon from "./IconBase.js";
const ArrowDownIcon = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 22 22" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="-2 -2 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5279 5.52794C11.7883 5.26759 12.2104 5.26759 12.4708 5.52794C12.7311 5.78829 12.7311 6.2104 12.4708 6.47075L8.47075 10.4708C8.21837 10.7231 7.81198 10.732 7.54887 10.4908L3.54887 6.82412C3.27745 6.57532 3.25912 6.15361 3.50791 5.8822C3.75671 5.61079 4.17842 5.59245 4.44983 5.84125L7.9793 9.07659L11.5279 5.52794Z"
          fill="#1C1D22"
        />
      </svg>
    </Icon>
  );
};
export default ArrowDownIcon;
